import React from "react";
import { useState, useEffect } from "react";
import logo from "../images/ses_rm.png";
import { motion } from "framer-motion";
import { db } from "../firebase";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Timestamp } from "firebase/firestore";
import Footer from "./Footer";

const HomeTest = () => {
  const [paintConPerDay, setPaintConPerDay] = useState(0);
  const [workingDaysPmonth, setWorkingDaysPmonth] = useState(0);
  const [totalPaintCpm, setTotalPaintCpm] = useState();
  const [transferEffGun, setTransferEffGun] = useState(0);
  const [totalWastage, setTotalWastage] = useState(0);
  const [paintLoss, setPaintLoss] = useState();
  const [aesolid, setAeSolid] = useState(0);
  const [actualPaintThrFilters, setActualPaintThrFilters] = useState();
  const [paintCarriedByPFpm, setPaintCarrirdByPFpm] = useState();
  const [density, setDensity] = useState(0);
  const [totalSolids, setTotalSolids] = useState();
  const [glassFiberArea, setGlassFiberArea] = useState(0);
  const [capacityOfFilter, setCapacityOfFilter] = useState(3.7);
  const [filtertionCapacity, setFilterCapacity] = useState();
  const [pDayTotalSolidWaste, setPDayTotalSolidWaste] = useState();
  const [replacementPeriod, setReplacementPeriod] = useState();
  const [replacementAfter, setReplacementAfter] = useState();
  const [costOfFilter, setCostOfFilter] = useState(0);
  const [totalCost, setTotalCost] = useState();
  const [costFilterChange, setCostFilterChange] = useState();
  const [costOfFilterChangePerAnnum, setCostOfFilterChangePerAnnum] =
    useState();

  const [showAns, setShowAns] = useState(false);
  const [mailVal, setMailVal] = useState("");

  const [isValid, setIsValid] = useState(false);
  const [message, setMessage] = useState("");

  const emailRegex = /\S+@\S+\.\S+/;

  const handler = (event) => {
    const email = mailVal;
    if (emailRegex.test(email)) {
      setIsValid(true);
      setShowAns(true);
      setMessage("");
    } else {
      setIsValid(false);
      setShowAns(false);
      setMessage("Please enter a valid email!");
    }

    const ans = paintConPerDay * workingDaysPmonth;
    setTotalPaintCpm(ans);

    const TW = 1.0 - transferEffGun / 100;
    setTotalWastage(TW);

    const PL = ans * TW;
    setPaintLoss(PL);

    const APThrF = (PL * aesolid) / 100;
    setActualPaintThrFilters(APThrF);

    const paintCarriedByPFpm_value = APThrF * 0.2;
    setPaintCarrirdByPFpm(paintCarriedByPFpm_value);

    const totalSolidsArrested = paintCarriedByPFpm_value * density;
    setTotalSolids(totalSolidsArrested);

    const filtertionCapacity_value = glassFiberArea * capacityOfFilter;
    setFilterCapacity(filtertionCapacity_value);

    const perDayTotalSolidWasteDisposalDesired_value =
      totalSolidsArrested / workingDaysPmonth;
    setPDayTotalSolidWaste(perDayTotalSolidWasteDisposalDesired_value);

    const replacementPeriod_value =
      filtertionCapacity_value / perDayTotalSolidWasteDisposalDesired_value;
    setReplacementPeriod(replacementPeriod_value);

    const replacementAfter_value = workingDaysPmonth / replacementPeriod_value;
    setReplacementAfter(replacementAfter_value);

    const totalCost_value = glassFiberArea * costOfFilter;
    setTotalCost(totalCost_value);

    const costFilterChange_value = totalCost_value * replacementAfter_value;
    setCostFilterChange(costFilterChange_value);

    const costOfFilterChangePerAnnum_value = costFilterChange_value * 12;
    setCostOfFilterChangePerAnnum(costOfFilterChangePerAnnum_value);
  };

  useEffect(() => {
    if (isValid) {
      // const addToDB = () => {
      db.collection("emaillist")
        .where("email", "==", mailVal)
        .get()
        .then((querySnap) => {
          // console.log(querySnap.docs.length)
          if (querySnap.docs.length === 0) {
            db.collection("emaillist")
              .add({
                mailVal,
                createdAt: Timestamp.now(),
              })
              .then(() => {
                //   Setmessage("you have subscribed successfully😃");
                console.log("email is added");
              })
              .catch((err) => {
                console.log("erro", err);
              });
          } else console.log("you have already subscribed");
        });
    }
  }, [isValid]);

  // }
  return (
    <div className="flex flex-col h-screen">
      <header className=" body-font sticky top-0">
        <div className="bg-zinc-900 mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
          <a
            href="https://stride-es.com"
            className="flex title-font font-medium items-center text-slate-50 mb-4 md:mb-0"
            target="_blank"
            rel="noreferrer noopener"
          >
            <div className="bg-white rounded-full ">
              <motion.div
                whileHover={{ scale: 1.2, rotate: 360 }}
                whileTap={{
                  scale: 0.8,
                  rotate: -90,
                  borderRadius: "100%",
                }}
              >
                <img src={logo} className="w-16 h-16 pt-2" alt="logo" />
              </motion.div>
            </div>
            <span className="heading_gradient mb-2 text-xl uppercase">
              <span className="text-red-600 uppercase">&nbsp;Filteration</span>{" "}
              Change Period
              <style jsx>{`
                .heading_gradient {
                  background: #ffff;
                  background-color: #fff;
                  background-image: radial-gradient(
                    circle,
                    #ffff 0,
                    #ff0000 26%,
                    #ffff 27%
                  );
                  background-position: 100% 100%;
                  background-size: 150%;
                  -webkit-animation-name: bg-circle;
                  animation-name: bg-circle;
                  -webkit-animation-duration: 10s;
                  animation-duration: 8s;
                  -webkit-animation-delay: 0s;
                  animation-delay: 0s;
                  -webkit-animation-iteration-count: infinite;
                  animation-iteration-count: infinite;
                  -webkit-animation-fill-mode: forwards;
                  animation-fill-mode: forwards;
                  background-repeat: no-repeat;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: transparent;
                }
                @keyframes bg-circle {
                  0% {
                    background-size: 350%;
                    background-position: left 100% bottom 0;
                  }
                  50% {
                    background-size: 350%;
                    background-position: left -10% bottom 0;
                  }
                  100% {
                    background-size: 350%;
                    background-position: left 100% bottom 0;
                  }
                }
              `}</style>
            </span>
          </a>
        </div>
      </header>
      <main className="overflow-y-scroll bg-zinc-800">
        <div className="flex  items-center  justify-center ">
          <form className="w-full max-w-lg shadow-lg p-6 m-2 bg-white ">
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0 ">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-first-name"
                >
                  Paint Consumption Per Day (Liters/Day)
                </label>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="username"
                  type="number"
                  placeholder=""
                  value={paintConPerDay}
                  onChange={(e) => setPaintConPerDay(e.target.value)}
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-last-name"
                >
                  Working days per month{" "}
                  <div className="invisible">.........................</div>
                </label>
                <div></div>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id=""
                  type="number"
                  placeholder=""
                  value={workingDaysPmonth}
                  onChange={(e) => setWorkingDaysPmonth(e.target.value)}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-first-name"
                >
                  Transfer efficiency of gun /surface area (%){" "}
                  <div className="invisible">
                    Solid Contains will be approx (%)
                  </div>
                </label>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="username"
                  type="number"
                  placeholder=""
                  value={transferEffGun}
                  onChange={(e) => setTransferEffGun(e.target.value)}
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-last-name"
                >
                  Considering Acrylic OR Epoxy paint Paint Solid Contains will
                  be approx (%){" "}
                  <div className="invisible">Solid Contains will be</div>
                </label>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id=""
                  type="number"
                  placeholder="Value will be calculated..."
                  value={aesolid}
                  onChange={(e) => setAeSolid(e.target.value)}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-first-name"
                >
                  PRIMARY Metal Filters will take approx paint load (%)
                  <div className="invisible">
                    Solid Contains will be approx (%)
                  </div>
                </label>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="username"
                  type="number"
                  placeholder=""
                  value={80}
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-last-name"
                >
                  Approx.Paint will go through SECONDARY paint arrestance
                  filters (%)
                </label>
                <div className="invisible">..</div>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id=""
                  type="number"
                  placeholder=""
                  value={20}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-first-name"
                >
                  Density
                  <div className="invisible">
                    (meter square To Be calculated based on Booth Filt )
                  </div>
                </label>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id=""
                  type="number"
                  placeholder=""
                  value={density}
                  onChange={(e) => setDensity(e.target.value)}
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-last-name"
                >
                  Glass fiber filters area (meter square (To Be calculated based
                  on Booth Filtration Size) )
                </label>
                <div></div>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id=""
                  type="number"
                  placeholder=""
                  value={glassFiberArea}
                  onChange={(e) => setGlassFiberArea(e.target.value)}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-first-name"
                >
                  Capacity of filter (kgs/m2)
                  <div className="invisible">
                    meter square (To Be calculated )
                  </div>
                </label>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id=""
                  type="number"
                  placeholder=""
                  value={capacityOfFilter}
                  onChange={(e) => setCapacityOfFilter(e.target.value)}
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-last-name"
                >
                  Cost of the filter (INR/m2)
                  <div className="invisible">
                    meter square (To Be calculated )
                  </div>
                </label>
                <div></div>
                <input
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id=""
                  type="number"
                  placeholder=""
                  value={costOfFilter}
                  onChange={(e) => setCostOfFilter(e.target.value)}
                />
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mt-6 ml-2">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    htmlFor="grid-"
                  >
                    Enter your mail to proceed
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Email"
                    onChange={(e) => setMailVal(e.target.value)}
                  />
                  <div
                    className={`message ${
                      isValid ? "success" : "error"
                    } text-red-600`}
                  >
                    {message}
                  </div>
                </div>
              </div>
            </div>
            {showAns && setIsValid ? (
              <>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      Total Paint Consumption Per Month (Liters/Month)
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={totalPaintCpm}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      Considering Paint loss in actual bounce back, Approx.
                      paint wastage per month (Liters)
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={paintLoss}
                      onChange={(e) => setPaintLoss(e.target.value)}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      So actual paint that will go through FILTERS (Liters)
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated"
                      value={actualPaintThrFilters}
                      onChange={(e) => setActualPaintThrFilters(e.target.value)}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      Paint carried by paint arrestance filters per month
                      (Liters)
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={paintCarriedByPFpm}
                      onChange={(e) => setPaintCarrirdByPFpm(e.target.value)}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      Total solids to be arrested (kgs of paint particles/month)
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={totalSolids}
                      onChange={(e) => setTotalSolids(e.target.value)}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      Filtertion capacity / change over (Kgs)
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={filtertionCapacity}
                      onChange={(e) => setGlassFiberArea(e.target.value)}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      per day total solid waste disposal desired (Kgs/day)
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={pDayTotalSolidWaste}
                      onChange={(e) => setPDayTotalSolidWaste(e.target.value)}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      Replacement Period (Days approx.)
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={replacementPeriod}
                      onChange={(e) => setReplacementPeriod(e.target.value)}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      Considering Max. uses we will consider replacement after
                      (times replacement/month )
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={replacementAfter}
                      onChange={(e) => setReplacementAfter(e.target.value)}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      Total Cost (per changeover)
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={totalCost}
                      onChange={(e) => setTotalCost(e.target.value)}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      Total Cost for filter change over per month (Rupees/Month)
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={costFilterChange}
                      onChange={(e) => setCostFilterChange(e.target.value)}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                      htmlFor="grid-"
                    >
                      Total Cost for filter change over per Annum
                    </label>
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-"
                      type=""
                      placeholder="Value will be calculated..."
                      value={costOfFilterChangePerAnnum}
                      onChange={(e) =>
                        setCostOfFilterChangePerAnnum(e.target.value)
                      }
                      disabled
                    />
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
            <div className="flex items-center justify-between">
              <button
                className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                type="button"
                onClick={handler}
              >
                Calculate
              </button>
            </div>
          </form>
        </div>
        {showAns && setIsValid && (
          <div className="flex flex-col">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                <div className="overflow-hidden bg-red-600">
                  <table className="min-w-full" id="table-excel">
                    <thead className="border-b">
                      <tr>
                        <th
                          scope="col"
                          className="text-sm font-medium text-white px-6 py-4 text-left"
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-white px-6 py-4 text-left"
                        >
                          Value
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-white px-6 py-4 text-left"
                        >
                          Units
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-gray-800 text-white">
                      <tr className="border-b ">
                        <td className="text-md font-light px-6 py-4 whitespace-nowrap">
                          Paint consumption per day
                        </td>
                        <td className="text-md font-light px-6 py-4 whitespace-nowrap">
                          {paintConPerDay}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Liters / day
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Working days per month
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {workingDaysPmonth}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          days
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Total Paint Consumption Per Month (Liters/Month)
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {totalPaintCpm}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Liters/Month
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Transfer efficiency of gun /surface area
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {transferEffGun}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          %
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Considering Paint loss in actual bounce back, Approx.
                          paint wastage per month
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {paintLoss}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Liters
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Considering Acrylic OR Epoxy paint Paint Solid
                          Contains will be approx
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {aesolid}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          %
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          So actual paint that will go through FILTERS
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {actualPaintThrFilters}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Liters
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          PRIMARY Metal Filters will take approx paint load
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          80
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          %
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Approx.Paint will go through SECONDARY paint
                          arrestance filters (%)
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          20
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          %
                        </td>
                      </tr>
                      <tr className=" border-b ">
                        <td className="text-md font-light px-6 py-4 whitespace-nowrap">
                          Paint carried by paint arrestance filters per month
                          (Liters)
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {paintCarriedByPFpm}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Liters
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Total solids to be arrested
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {totalSolids}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap"></td>
                      </tr>

                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Glass fiber filters area (To Be calculated based on
                          Booth Filtration Size)
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {glassFiberArea}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          meter square
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Capacity of filter
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {capacityOfFilter}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          kgs/m2
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Filtertion capacity / change over
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {filtertionCapacity}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Kgs
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          per day total solid waste disposal desired
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {pDayTotalSolidWaste}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Kgs/day
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Replacement Period
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {replacementPeriod}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Days approx
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Considering Max. uses we will consider replacement
                          after
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {replacementAfter}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          times replacement/month
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Cost of the Filter
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {costOfFilter}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          INR/m2
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Total Cost
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {totalCost}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          (per changeover)
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Total Cost for filter change over per month
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {costFilterChange}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Rupees/Month
                        </td>
                      </tr>
                      <tr className=" border-b">
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Total Cost for filter change over per Annum
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          {costOfFilterChangePerAnnum}
                        </td>
                        <td className="text-md  font-light px-6 py-4 whitespace-nowrap">
                          Rs
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        <div>
          <div className="flex flex-col mx-2.5">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <div className="flex flex-col">
                    <div className="overflow-x-auto sm:-mx-6 lg:-mx-8"></div>
                  </div>
                </div>

                {showAns && (
                  <div className="m-4 flex items-center justify-between">
                    <button
                      className=" bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded inline-flex focus:outline-none focus:shadow-outline"
                      type="button"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="flex-1 h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                      <span>
                        <ReactHTMLTableToExcel
                          className="btn flex-1"
                          table="table-excel"
                          filename="Stride_Calculation_excel"
                          sheet="Sheet"
                          buttonText="Download excel"
                        />
                      </span>
                    </button>
                  </div>
                )}
              </div>
              <Footer />
              <a
                target={"_blank"}
                href="https://wa.me/917248994600"
                title="For any queries contact"
                class="fixed z-90 bottom-20 right-8 bg-green-600 w-16 h-16 rounded-full drop-shadow-lg flex justify-center items-center text-white text-4xl hover:bg-green-700 hover:drop-shadow-2xl hover:animate-bounce duration-300 hover:opacity-25"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  className="bi bi-whatsapp h-10 w-10 "
                  viewBox="0 0 16 16"
                >
                  <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />{" "}
                </svg>
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HomeTest;
